import { createActions } from 'redux-actions';

export const { addLoaderMessage, clearLoaderMessage } = createActions(
  {
    ADD_LOADER_MESSAGE: message => ({ message }),
  },
  'CLEAR_LOADER_MESSAGE',
);



// WEBPACK FOOTER //
// ./src/store/actions/Loader/index.js